import React, { Component } from "react";
import {
  Modal,
} from "react-bootstrap";
import { connect } from "react-redux";
import { TextField } from "@rmwc/textfield";
import { Checkbox } from "@rmwc/checkbox";
import * as actionCreator from "../../action/index.js";
import * as validate from "./validations";
import Likeactive from "../../assets/images/feedback/like-active.svg";
import Likenormal from "../../assets/images/feedback/like-normal.svg";
import confused from "../../assets/images/emoji/confused.svg";
import happy from "../../assets/images/emoji/happy.svg";
import love from "../../assets/images/emoji/love.svg";
import very_sad from "../../assets/images/emoji/sad.svg";
import sad from "../../assets/images/emoji/sad-2.svg";
import ConfettiExplosion from 'react-confetti-explosion';
import AnimButton from "../Button/AnimButton.js";
class Feedback extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         displayFeedBackError : {
            first_name: "",
            last_name: "qeqwe",
            email:"qweqwe",
            phone_number:"qweqwe",
         }
      };
   }


   custom(){
      document.getElementsByClassName("modal")[0].style.transform = "scale(0)"
      document.getElementsByClassName("modal")[0].style.transition = "0.6s"
      setTimeout(() => {
         this.props.handleShowfeedback("prompt")
      },500)
   }

   render() {
      const emojisArray = [very_sad, sad, confused, happy, love];

      return (
         <div>
         <Modal
            centered
            show={this.props.isShowfeedback}
            backdrop="static"
            keyboard={false}
            onHide={(e) => this.props.handleShowfeedback("prompt")}
            dialogClassName={
               this.props.isShowfeedbackloader == true
               ? "feedback-modal react-modal form-submiting"
               : "feedback-modal react-modal"
            }
            backdropClassName="ract-modal-pre-parent"
         >
            <button
               className="close"
               onClick={(e) => this.custom()}
            >
               <span className="icon-close"></span>
            </button>

            <Modal.Body
               className={
               this.props.isFeedbackcontent != true ? "improvemodal-wrapper" : ""
               }
            >
               {this.props.isFeedbackcontent == false && this.props.const_var.feedback_object_to_server.success == false && (
                  <>
                     <div
                        className={
                        this.props.const_var.feedback_object_to_server.success ==
                        false
                           ? "before-thankyou "
                           : "before-thankyou d-none"
                        }
                     >
                        <div className="row">
                        <div className="col-12">
                           <h5 class="modal-title text-uppercase mb-3">feedback</h5>
                        </div>
                        </div>

                        <div className="row">
                        <div className="likes-section col-12">
                           <a>
                              <span
                              className={
                                 this.props.const_var.feedback_object_to_server
                                    .dislike_count == true
                                    ? "icon disabled"
                                    : "icon"
                              }
                              onClick={(e) =>
                                 this.props.handleShowfeedback("like", e)
                              }
                              >
                              {this.props.const_var.feedback_object_to_server
                                 .like_count == true ? (
                                 <img
                                    src={process.env.REACT_APP_BASE_URL + Likeactive}
                                 />
                              ) : (
                                 <img
                                    src={process.env.REACT_APP_BASE_URL + Likenormal}
                                 />
                              )}
                              </span>
                              <span className="likes-counter">
                              {this.props.const_var.feedback_object.like_count}
                              </span>
                           </a>
                        </div>
                        <div className="col-6 mb-3">
                           <div className="floating-label-input">
                              <TextField
                              value={
                                 this.props.const_var.feedback_object_to_server
                                    .feedback_name
                              }
                              label="Name"
                              onChange={(e) =>
                                 this.props.handleShowfeedback("feedback_name", e)
                              }
                              />
                           </div>
                        </div>{" "}
                        <div className="col-6 mb-3">
                           <div
                              className={
                              this.props.const_var.displayerrorMessage.email ==
                                 "" ||
                              this.props.const_var.displayerrorMessage.email ==
                                 undefined
                                 ? "floating-label-input"
                                 : "floating-label-input invalid-input"
                              }
                           >
                              <TextField
                              value={
                                 this.props.const_var.feedback_object_to_server
                                    .feedback_email
                              }
                              label="Email"
                              onChange={(e) =>
                                 this.props.handleShowfeedback("feedback_email", e)
                              }
                              onBlur={(e) => validate.checkValidEmail(e)}
                              />
                              <span className="error-icon icon-info-ico"></span>
                              <div className="errorMessage" id="emailErrorMessage">
                              {this.props.const_var.displayerrorMessage.email}
                              </div>
                           </div>
                        </div>
                        <div className="col-12">
                           <div className="floating-label-input">
                              <TextField
                              textarea
                              value={
                                 this.props.const_var.feedback_object_to_server
                                    .feedback
                              }
                              fullwidth
                              label="Feedback"
                              rows={window.innerWidth < 993 ? 2 : 4}
                              maxLength={1000}
                              onChange={(e) =>
                                 this.props.handleShowfeedback("feedback", e)
                              }
                              characterCount
                              helpText={{
                                 persistent: true,
                              }}
                              />
                           </div>
                        </div>
                        <div className="col-12 text-center mt-5">
                           <button
                              className={
                              this.props.const_var.feedback_object_to_server
                                 .feedback == "" ||
                              this.props.const_var.feedback_object_to_server
                                 .feedback_name == "" ||
                              this.props.const_var.feedback_object_to_server
                                 .feedback_email == "" ||
                              this.props.const_var.displayerrorMessage.email != ""
                                 ? "pushable pushable-with-left-right pushable-dark disabled"
                                 : "pushable pushable-with-left-right pushable-dark"
                              }
                              onClick={(e) =>
                              this.props.handleShowfeedback("submit", e)
                              }
                           >
                              <span className="edge"></span>
                              <div className="front">
                              <span className="saving-effect">
                                 <span></span>
                                 <span></span>
                                 <span></span>
                              </span>
                              <div className="front-left">
                                 <span className="text">SUBMIT</span>
                              </div>
                              <div className="front-right">
                                 <span className="icon icon-arrow-double-small"></span>
                              </div>
                              </div>
                           </button>
                        </div>
                        </div>
                     </div>
                  </>
               )} 
               {this.props.isFeedbackcontent == true && this.props.const_var.feedback_object_to_server.success == false && (
                  <div className="improve-section">
                     <div className="improve-top">
                        <div className="feedback-title">
                           Feedback
                        </div>
                        <div className="feedback-content">
                           We’d love to hear about your experience. Let us know how we can make it even better for you.
                        </div>
                        <ul className="improve-icons" style={{marginBottom: (this.props.emojiname == "very_sad" || this.props.emojiname == "sad") ? '20px': '30px'}}>
                        {emojisArray.map((val, index) => {
                           return (
                              <li>
                              <a
                                 className={
                                    this.props.emojiindex == index ? "active" : ""
                                 }
                                 onClick={(e) =>
                                    this.props.handleShowfeedback("emojis", e, index)
                                 }
                              >
                                 <img src={process.env.REACT_APP_BASE_URL+val} />
                              </a>
                              </li>
                           );
                        })}
                        </ul>
                     </div>

                     <div className="improve-bottom">
                        <div className="">
                           <div className= {this.props.emojiname != "very_sad" &&  this.props.emojiname != "sad" ? '' : 'sad-container'}>
                              {(this.props.emojiname == "very_sad" ||
                                 this.props.emojiname == "sad") && (
                                 <div>
                                    <p style={{ textAlign: "left", fontSize: "12px" }}>
                                    Uh-oh, we will work on it, could you please specify
                                    what made you unhappy?
                                    </p>
                                 </div>
                              )}

                              <div className= {
                                    this.props.const_var.displayerrorMessage.feedback ==
                                       "" ||
                                       this.props.const_var.displayerrorMessage.feedback ==
                                       undefined
                                       ? "floating-label-input"
                                       : "floating-label-input invalid-input"
                                          }>
                                 <TextField
                                 textarea
                                 value={
                                    this.props.const_var.feedback_object_to_server
                                       .feedback
                                 }
                                 fullwidth
                                 placeholder="Write your feedback here…"
                                 rows={(this.props.emojiname == "very_sad" || this.props.emojiname == "sad") && window.innerWidth < 993 ? 2 : 4}
                                 maxLength={1000}
                                 onChange={(e) =>
                                    this.props.handleShowfeedback("feedback", e)
                                 }
                                 characterCount
                                 />
                                 <span className="error-icon icon-info-ico"></span>
                                 <div className="errorMessage" id="fnameErrorMessage">{this.props.const_var.displayerrorMessage.feedback}</div>
                              </div>

                              {(this.props.emojiname == "very_sad" ||
                                 this.props.emojiname == "sad") && (
                                 <>
                                    <div className="mt-2 text-left">
                                       <div className="checkbox">
                                          <Checkbox
                                             className="secondary"
                                             ripple="RipplePropF"
                                             id="threed_remember"
                                             label="Get notified about your issue"
                                             checked={this.props.const_var.isFeedbackFieldMandatory}
                                             onClick={(e) => this.props.handleFeedbackMandatory(e.target.checked)}
                                          />
                                       </div>
                                    </div>
                                 </>
                              )}
                           </div>
                           {(this.props.emojiname == "very_sad" ||
                              this.props.emojiname == "sad") && (
                              <div className="mt-2">
                                 <div className="info-container">
                                    <div className="info-item">
                                       <div className="info-label">First Name</div>
                                       <div className= {
                                             this.props.const_var.displayerrorMessage.feedback_first_name ==
                                             "" ||
                                             this.props.const_var.displayerrorMessage.feedback_first_name ==
                                             undefined
                                             ? "floating-label-input"
                                             : "floating-label-input invalid-input"
                                          }>
                                          <TextField
                                             value={
                                             this.props.const_var.feedback_object_to_server
                                                .first_name
                                             }
                                             onChange={(e) =>
                                             this.props.handleShowfeedback(
                                                "first_name",
                                                e
                                             )
                                             }
                                          />
                                          <span className="error-icon icon-info-ico"></span>
                                          <div className="errorMessage" id="fnameErrorMessage">{this.props.const_var.displayerrorMessage.feedback_first_name}</div>
                                       </div>
                                    </div>
                                    <div className="info-item">
                                       <div className="info-label">Last Name</div>
                                       <div className={
                                             this.props.const_var.displayerrorMessage.feedback_last_name ==
                                             "" ||
                                             this.props.const_var.displayerrorMessage.feedback_last_name ==
                                             undefined
                                             ? "floating-label-input"
                                             : "floating-label-input invalid-input"
                                          }>
                                          <TextField
                                             value={
                                             this.props.const_var.feedback_object_to_server
                                                .last_name
                                             }
                                             onChange={(e) =>
                                             this.props.handleShowfeedback(
                                                "last_name",
                                                e
                                             )
                                             }
                                          />
                                          <span className="error-icon icon-info-ico"></span>
                                           <div
                                             className="errorMessage"
                                             id="emailErrorMessage"
                                          >
                                             {this.props.const_var.displayerrorMessage.feedback_last_name}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="info-container">
                                    <div className="info-item">
                                       <div className="info-label">Email</div>
                                       <div
                                          className={
                                             this.props.const_var.displayerrorMessage.feedback_email ==
                                             "" ||
                                             this.props.const_var.displayerrorMessage.feedback_email ==
                                             undefined
                                             ? "floating-label-input"
                                             : "floating-label-input invalid-input"
                                          }
                                       >
                                          <TextField
                                             value={
                                             this.props.const_var.feedback_object_to_server
                                                .feedback_email
                                             }
                                             onChange={(e) =>
                                             this.props.handleShowfeedback(
                                                "feedback_email",
                                                e
                                             )
                                             }
                                             onBlur={(e) => validate.checkValidEmail(e)}
                                          />
                                          <span className="error-icon icon-info-ico"></span>
                                          <div
                                             className="errorMessage"
                                             id="emailErrorMessage"
                                          >
                                             {this.props.const_var.displayerrorMessage.feedback_email}
                                          </div>
                                       </div>
                                    </div>
                                    <div className="info-item phone-number">
                                       <div className="info-label">Phone Number</div>
                                       <div   className={
                                          this.props.const_var.displayerrorMessage.feedback_phone_number ==
                                             "" ||
                                             this.props.const_var.displayerrorMessage.feedback_phone_number ==
                                             undefined
                                             ? "floating-label-input"
                                             : "floating-label-input invalid-input"
                                          }>
                                          <TextField
                                             value={
                                             this.props.const_var.feedback_object_to_server
                                                .phone_number
                                             }
                                             onChange={(e) =>{
                                                validate.checkValidMobileNumberForOtherField(e)
                                                this.props.handleShowfeedback(
                                                   "phone_number",
                                                   e
                                                )
                                             }}
                                             maxLength={10}
                                             
                                          />
                                          <span className="error-icon icon-info-ico"></span>
                                          <div
                                             className="errorMessage"
                                             id="emailErrorMessage"
                                          >
                                             {this.props.const_var.displayerrorMessage.feedback_phone_number}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           )}
                        <div className="action-container">
                           <button className={"btn btn-default"} onClick={(e) => this.custom()}>
                              CANCEL
                           </button>
                           <button
                              className={'btn btn-primary'}
                              onClick={(e) =>{
                                    this.props.handleShowfeedback("submit", e);         
                                 }
                              }
                           >
                              SUBMIT
                           </button>
                        </div>
                        </div>
                     </div>
                  </div>
               )}
               {
                  this.props.const_var.feedback_object_to_server.success == true &&
                  <div className={"thankyou-feedback"}>
                     <div className="thankyou-feedback-inner">
                        <div className="thankyou-icon">
                           <ConfettiExplosion colors={['#fecbc4','#5fc8a6','#fac82b','#cfaa04']} className="confetti" zIndex="1000000" duration="4000"  particleCount="500"  width="1600"/>
                           <div className="icon-check-container">
                           <div className="thankyou-check">
                              <span class="icon-checkmark-ico"></span>
                           </div>
                              {/* <i className="icon-check"></i> */}
                           </div>
                        </div>
                        <div className="thankyou-title">Thank you!</div>
                        <div className="thankyou-content">Thank you for your trust in us! We’re committed to your satisfaction and always here to help. If you need anything, just let us know. Cheers to our continued journey together!</div>
                     </div>
                  </div>
               }
            </Modal.Body>
         </Modal>
         </div>
      );
   }
}

const mapStoreToProps = (state) => {
  return state.reducer;
};



export default connect(mapStoreToProps, actionCreator)(Feedback);
